import { SettingService } from './../../../../shared/services/setting.service';
import { ISetting } from './../../../../_models/cms/ISetting';
import { ProfileService } from './../../../../shared/services/profile.service';
import { IProfile, IProfileStatus } from './../../../../_models/account/IProfile';
import { ToastrService } from 'ngx-toastr';
import { Component, Input, OnChanges, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-employee-form',
  templateUrl: './employee-form.component.html'
})
export class EmployeeFormComponent implements OnInit, OnChanges {
  @Input() profile: IProfile;
  @Output() closeForm: EventEmitter<any> = new EventEmitter();
  loading: boolean;
  title: string = 'Employee Status';
  @Input() profileStatus: IProfileStatus;
  profileStatusForm: FormGroup;

  setting: ISetting;
  constructor(private router: Router,
    private fb: FormBuilder,
    private toastrService: ToastrService,
    private service: ProfileService,
    private settingService: SettingService,
    private modalService: NgbModal) {
    this.createProfileForm();
  }

  async ngOnInit() {
    this.setting = await this.settingService.getSetting();
    if (!this.setting.isProfileRO) {
      this.toastrService.warning("ro approval module closed!");
      this.modalService.dismissAll();
    }

    if (this.profile) {
      this.setValueProfileForm();
    }
  }

  ngOnChanges() {
    if (this.profile) {
      this.setValueProfileForm();
    }
  }

  createProfileForm() {
    this.profileStatusForm = this.fb.group({
      id: ['0'],
      profileId: [''],
      financialYearId: ['', Validators.required],
      isRODisabled: [false],
      isRODisease: [false],
      isROSingleWomen: [false],
      isROSpouseIn: [false],
      isROSpouseOut: [false],
      isRODueForRetire: [false],
      isROApproved: ['', Validators.required],
      roRemark: ['']
    });

    if (this.profile) {
      this.setValueProfileForm();
    }
  }

  get isDisabledInfo() {
    return this.profile && this.profile.disabledInfos.length > 0 ? true : false;
  }

  get isDiseaseInfo() {
    return this.profile && this.profile.diseaseInfos.length > 0 ? true : false;
  }

  get isSingleWomenInfo() {
    return this.profile && this.profile.singleWomenInfos.length > 0 ? true : false;
  }

  get isSpouseInInfo() {
    return this.profile && this.profile.spouseInInfos.length > 0 ? true : false;
  }

  get isSpouseOutInfo() {
    return this.profile && this.profile.spouseOutInfos.length > 0 ? true : false;
  }

  get isRODueForRetireInfo() {
    // return this.profile && this.profile.isRetirementNear != null ? this.profile.isRetirementNear == true ? true : false : false;
    return this.profile && this.profile.isRetirementNear == true  ? true : false;
  }

  setValueProfileForm() {
    this.profileStatus = this.profile?.profileStatuses ? this.profile?.profileStatuses[0] : null;

    this.profileStatusForm.patchValue({
      profileId: this.profile.userId,
      financialYearId: this.setting?.financialYearId,
      isROApproved: this.profile?.isROApproved,
      roRemark: this.profile.roRemark
    });


    if (this.profileStatus) {
      this.profileStatusForm.patchValue({
        id: this.profileStatus.id,
        isRODisabled: this.profileStatus.isRODisabled,
        isRODisease: this.profileStatus.isRODisease,
        isROSingleWomen: this.profileStatus.isROSingleWomen,
        isROSpouseIn: this.profileStatus.isROSpouseIn,
        isROSpouseOut: this.profileStatus.isROSpouseOut,
        isRODueForRetire: this.profileStatus.isRODueForRetire,
      });
    }  
  }

  save() {
    if (this.profileStatusForm.valid) {
      this.loading = true;
      this.profileStatus = Object.assign({}, this.profileStatusForm.value);
      if (this.profileStatus) {
        this.service.updateStatusRegion(this.profileStatus).subscribe(() => {
          this.toastrService.success('profile status updated successfully');
          this.closeForm.emit();
        },
          (error) => console.log('HTTP Error', error),
          () => this.loading = false);
      }
    }
  }

  close() {
    this.modalService.dismissAll();
  }
}
